module.exports = __webpack_public_path__ + "static/SSB_logo_original-1f60b3e38f70906fe475a5ed02539226.svg";